import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    // iconfont: 'md',
    values: {
      fb: 'img/icons/facebook.png',
    },
  },
  theme: {
    disable: true,
    // options: {
    //   cspNonce: 'dQw4w9WgXcQ',
    // },
  },
});
